class StaticValue {
    static baseURL = process.env.NEXT_PUBLIC_API_BASE_URL || 'https://api.hartcollege.ca';
    // static baseURL = 'https://api.hartcollege.ca';   
}

export default StaticValue;



// Server Access
// https://app.hartcollege.ca/
// 145.223.120.54
// root
// pj@#vaL72?bp
// only front end hosted